const TOKEN_KEY = "pontepie_admin_token";
export const AUTH_EXPIRED_EVENT = "pontepie-auth-expired";

export function apiUrl(path: string): string {
  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  if (!base) return path.startsWith("/") ? path : `/${path}`;
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

export function getAdminToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token: string | null): void {
  if (!token) localStorage.removeItem(TOKEN_KEY);
  else localStorage.setItem(TOKEN_KEY, token);
}

export async function apiFetch(
  path: string,
  init?: RequestInit & { json?: unknown }
): Promise<Response> {
  const { json, headers, ...rest } = init || {};
  const h = new Headers(headers);
  if (json !== undefined) {
    h.set("Content-Type", "application/json");
  }
  return fetch(apiUrl(path), {
    ...rest,
    headers: h,
    body: json !== undefined ? JSON.stringify(json) : rest.body,
  });
}

type ApiErrorShape = {
  error?: string | { message?: string };
};

function readApiErrorMessage(body: ApiErrorShape | null, fallback: string): string {
  if (!body || typeof body !== "object") return fallback;
  if (typeof body.error === "string") return body.error;
  if (body.error && typeof body.error.message === "string") return body.error.message;
  return fallback;
}

export async function readApiBody<T>(res: Response, defaultError: string): Promise<T> {
  const body = (await res.json().catch(() => null)) as
    | ({ ok?: boolean; data?: unknown } & ApiErrorShape)
    | null;

  if (!res.ok) {
    throw new Error(readApiErrorMessage(body, defaultError));
  }

  if (body && typeof body === "object" && body.ok === true && "data" in body) {
    return body.data as T;
  }

  return body as T;
}

export async function adminFetch(
  path: string,
  init?: RequestInit & { json?: unknown }
): Promise<Response> {
  const token = getAdminToken();
  const { json, headers, ...rest } = init || {};
  const h = new Headers(headers);
  if (token) h.set("Authorization", `Bearer ${token}`);
  if (json !== undefined) h.set("Content-Type", "application/json");
  const res = await fetch(apiUrl(path), {
    ...rest,
    headers: h,
    body: json !== undefined ? JSON.stringify(json) : rest.body,
  });
  if (res.status === 401 && path.includes("/api/admin")) {
    setAdminToken(null);
    window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
  }
  return res;
}
